const dashboardES = {
    "view": {
        "label": {
            "allTimeSales": "Ventas Totales",
            "totalToBePaid": "Total a Pagar",
            "promoCoins": "Monedas Promocionales",
            "promoDownloadCount": "Conteo de Descargas Promocionales",
            "promoFeedbackCount": "Conteo de Comentarios Promocionales",
            "totalDownloads": "Descargas Totales",
            "totalFeedbacks": "Comentarios Totales"
        },
        "options": {
            "earnings": {
                "allTime": "Ganancias Totales",
                "last12Months": "Últimos 12 Meses"
            },
            "months": {
                "jan": "Ene",
                "feb": "Feb",
                "mar": "Mar",
                "apr": "Abr",
                "may": "May",
                "jun": "Jun",
                "jul": "Jul",
                "aug": "Ago",
                "sep": "Sep",
                "oct": "Oct",
                "nov": "Nov",
                "dec": "Dic"
            }
        },
        "message": {
            "userWelcomeTitle": "Hola {{firstName}}, bienvenido de nuevo a la Plataforma Music Link.",
            "ownedAndManaged": "Tu cuenta es propiedad y está gestionada por <1>{{ parent_company }}</1>, visita nuestra <3>Página de Ayuda</3> para saber más.",
            "completeInformation": "Aún no has enviado tu información, por favor <1><strong>Completa Tu Información</strong></1> para continuar!",
            "notSubscribed": "No estás suscrito a ningún plan. ¡Suscríbete ahora para desbloquear todo el potencial de la plataforma Music Link!",
            "accountBlacklisted": "Tu cuenta ha sido negra lista después de la revisión como hemos encontrado que la información asociada con tu cuenta está vinculada con uno de los usuarios internacionalmente negros en nuestro sistema. Como resultado, hemos desactivado la función de distribución para tu cuenta.",
        }
    }
};

export default dashboardES;